// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1_pzz","active":"Tag_active__21KqO"};